import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orange-ramadan-footer',
  templateUrl: './orange-ramadan-footer.component.html',
  styleUrls: ['./orange-ramadan-footer.component.css']
})
export class OrangeRamadanFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
